import http from '@/plugins/axios/axios';

export default class SolicitacaoService {
    
    listar(requisicao) {       
        return http.post('/api/solicitacao/listar', requisicao);
    } 
    
    listarPendentesPorFuncionario(requisicao) {       
        return http.post('/api/solicitacao/listar-pendentes-funcionario', requisicao);
    } 
}